import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { type ShipmentOrderInputHistoryDetailEntity } from '@/libs/api'

import { getShipmentOrderHistoryDetailQueryOption } from '../query-options/get-shipment-order-history-detail-query-option'

/**
 * 配送依頼履歴詳細のUseQuery
 */
export const useShipmentOrderHistoryDetailQuery = (
  tenantKey: string,
  id: number | null,
  options?: {
    disabled?: boolean
  }
): UseQueryResult<ShipmentOrderInputHistoryDetailEntity> => {
  const disabled = options?.disabled || id === null || id === 0
  return useQuery<ShipmentOrderInputHistoryDetailEntity>({
    ...getShipmentOrderHistoryDetailQueryOption(tenantKey, id ?? 0),
    enabled: !disabled,
    retry: false
  })
}
